import { render, staticRenderFns } from "./SettingsUsers.vue?vue&type=template&id=0d9dcdc9&scoped=true&"
import script from "./SettingsUsers.vue?vue&type=script&lang=js&"
export * from "./SettingsUsers.vue?vue&type=script&lang=js&"
import style0 from "./SettingsUsers.vue?vue&type=style&index=0&id=0d9dcdc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9dcdc9",
  null
  
)

export default component.exports